export default __webpack_public_path__ + "static/media/forest-bird-woman.daa96fa1.jpg";